(() => {
  const MODULE_SELECTOR = '[data-tale-product-personalization]';
  const ADD_SELECTOR = '[data-tale-personalization-add]';

  const getCartDrawer = () => document.querySelector('cart-drawer');

  const getCartAddUrl = () => {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    if (typeof routes !== 'undefined' && routes.cart_add_url) return routes.cart_add_url;
    return '/cart/add.js';
  };

  const getFetchConfig = () => {
    if (typeof fetchConfig === 'function') {
      const config = fetchConfig('javascript');
      return {
        ...config,
        headers: {
          ...config.headers,
          Accept: 'application/json',
          'Content-Type': 'application/json'
        }
      };
    }

    return {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    };
  };

  const getSectionsPayload = () => {
    const cartDrawer = getCartDrawer();

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      return cartDrawer.getSectionsToRender().map((section) => section.section);
    }

    return ['cart-counter', 'cart-drawer'];
  };

  const notifyCartChanged = (payload) => {
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: payload
      })
    );

    document.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: payload
      })
    );

    document.dispatchEvent(
      new CustomEvent('tale:cart:updated', {
        bubbles: true,
        detail: payload
      })
    );

    if (typeof updateCartCounters === 'function') updateCartCounters();
    if (typeof updateFreeShipping === 'function') updateFreeShipping();
  };

  const openCartDrawerFallback = () => {
    const cartDrawer = getCartDrawer();

    if (!cartDrawer) {
      return false;
    }

    if (typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return true;
    }

    cartDrawer.classList.add('is-visible');
    document.body.style.overflow = 'hidden';

    return true;
  };

  const renderCartDrawer = (response) => {
    const cartDrawer = getCartDrawer();

    if (cartDrawer && typeof cartDrawer.renderContents === 'function' && response.sections) {
      try {
        cartDrawer.renderContents(response, true);
        return;
      } catch (error) {
        console.warn('[TALE personalization] Cart drawer render edilemedi, sadece sepet güncellendi.', error);
      }
    }

    notifyCartChanged(response);
    openCartDrawerFallback();
  };

  const setButtonState = (button, state) => {
    button.classList.remove('is-loading', 'is-added', 'has-error');

    if (state === 'loading') {
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = '<span aria-hidden="true">…</span>';
      return;
    }

    button.removeAttribute('aria-busy');

    if (state === 'added') {
      button.classList.add('is-added');
      button.innerHTML = '<span aria-hidden="true">✓</span>';

      window.setTimeout(() => {
        button.classList.remove('is-added');
        button.innerHTML = '<span aria-hidden="true">+</span>';
      }, 1400);

      return;
    }

    if (state === 'error') {
      button.classList.add('has-error');
      button.innerHTML = '<span aria-hidden="true">!</span>';

      window.setTimeout(() => {
        button.classList.remove('has-error');
        button.innerHTML = '<span aria-hidden="true">+</span>';
      }, 1600);

      return;
    }

    button.innerHTML = '<span aria-hidden="true">+</span>';
  };

  const addVariantToCart = async (button) => {
    const variantId = button.dataset.variantId;

    if (!variantId || button.disabled || button.classList.contains('is-loading')) return;

    setButtonState(button, 'loading');

    const body = {
      id: Number(variantId),
      quantity: 1,
      sections: getSectionsPayload(),
      sections_url: window.location.pathname
    };

    try {
      const response = await fetch(getCartAddUrl(), {
        ...getFetchConfig(),
        body: JSON.stringify(body)
      });

      const parsedResponse = await response.json();

      if (!response.ok) {
        throw parsedResponse;
      }

      renderCartDrawer(parsedResponse);
      notifyCartChanged(parsedResponse);
      setButtonState(button, 'added');
    } catch (error) {
      console.error('[TALE personalization] Sepete ekleme hatası:', error);
      setButtonState(button, 'error');
    }
  };

  const randomizePersonalizationGroups = (module) => {
    if (!module || module.dataset.randomReady === 'true') return;
    
    const groups = module.querySelectorAll('[data-tale-random-group]');
    
    groups.forEach((group) => {
      const cards = Array.from(group.querySelectorAll('.tale-personalization-card'));
      const visibleCount = Number(group.dataset.visibleCount || 4);
    
      if (!cards.length) return;
    
      cards.forEach((card) => {
        card.classList.remove('is-random-visible');
        card.hidden = true;
      });
    
      const shuffledCards = [...cards].sort(() => Math.random() - 0.5);
      const selectedCards = shuffledCards.slice(0, visibleCount);
    
      selectedCards.forEach((card) => {
        card.classList.add('is-random-visible');
        card.hidden = false;
        group.appendChild(card);
      });
    });
  
    module.dataset.randomReady = 'true';
  };

  const init = () => {
    document.querySelectorAll(MODULE_SELECTOR).forEach((module) => {
      if (module.dataset.initialized === 'true') return;

      module.dataset.initialized = 'true';

      randomizePersonalizationGroups(module);

      module.addEventListener('click', (event) => {
        const button = event.target.closest(ADD_SELECTOR);

        if (!button) return;

        event.preventDefault();
        event.stopPropagation();

        addVariantToCart(button);
      });
    });
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();


(function () {
  const TARGET_TITLES = ['ürün özellikleri', 'ürün ölçüleri'];

  function normalizeText(text) {
    return (text || '')
      .toLocaleLowerCase('tr-TR')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getAccordionTitle(block) {
    const accordion =
      block.closest('.accordion') ||
      block.closest('details') ||
      block.closest('.product__accordion') ||
      block.closest('.collapsible-content') ||
      block.closest('.accordion-item');

    if (!accordion) return '';

    const titleEl =
      accordion.querySelector('.accordion__title') ||
      accordion.querySelector('.accordion__button') ||
      accordion.querySelector('.accordion__summary') ||
      accordion.querySelector('summary') ||
      accordion.querySelector('button') ||
      accordion.querySelector('h2, h3, h4');

    return normalizeText(titleEl ? titleEl.textContent : '');
  }

  function shouldTransformBlock(block) {
    const title = getAccordionTitle(block);

    if (!title) return false;

    return TARGET_TITLES.some((targetTitle) => title.includes(targetTitle));
  }

  function getLinesFromBlock(block) {
    const html = block.innerHTML || '';

    return html
      .replace(/<script[\s\S]*?<\/script>/gi, '')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/<\/p>/gi, '\n')
      .replace(/<[^>]+>/g, '')
      .split('\n')
      .map((line) => line.trim())
      .filter(Boolean);
  }

  function renderBulletList(block, lines) {
    if (!lines.length) return;

    const list = document.createElement('ul');
    list.className = 'tale-metafield-bullets';

    lines.forEach((line) => {
      const item = document.createElement('li');
      item.className = 'tale-metafield-bullets__item';
      item.textContent = line;
      list.appendChild(item);
    });

    block.innerHTML = '';
    block.appendChild(list);
    block.dataset.taleBulletsApplied = 'true';
  }

  function transformMetafieldBlocks() {
    const blocks = document.querySelectorAll('.product__metafield_for_variant-block');

    blocks.forEach((block) => {
      if (!shouldTransformBlock(block)) return;

      if (block.querySelector('.tale-metafield-bullets')) return;

      const lines = getLinesFromBlock(block);
      renderBulletList(block, lines);
    });
  }

  function observeMetafieldChanges() {
    const blocks = document.querySelectorAll('.product__metafield_for_variant-block');

    blocks.forEach((block) => {
      if (block.dataset.taleBulletObserver === 'true') return;

      const observer = new MutationObserver(() => {
        window.requestAnimationFrame(() => {
          if (!shouldTransformBlock(block)) return;
          if (block.querySelector('.tale-metafield-bullets')) return;

          const lines = getLinesFromBlock(block);
          renderBulletList(block, lines);
        });
      });

      observer.observe(block, {
        childList: true,
        subtree: true,
        characterData: true
      });

      block.dataset.taleBulletObserver = 'true';
    });
  }

  function initTaleMetafieldBullets() {
    transformMetafieldBlocks();
    observeMetafieldChanges();
  }

  document.addEventListener('DOMContentLoaded', initTaleMetafieldBullets);
  document.addEventListener('shopify:section:load', initTaleMetafieldBullets);

  window.addEventListener('load', initTaleMetafieldBullets);
})();